import React ,{ useEffect , useState}  from "react";
import { getToken } from '../utils/cookieUtils';
import Nav from "../components/Nav";
import LoggedNav from "../components/LoggedNav";
import {  useLocation } from "react-router-dom";
import SubscriptionMessageScreen from "../components/SubscriptionMessageScreen";

function SubscriptionMessage(props) {

  const { state } = useLocation();

  useEffect(() => {

    //console.log(state);
    
 

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {getToken() ? <LoggedNav customer={props.customer} /> : <Nav customer={props.customer} />}
 
      <SubscriptionMessageScreen customer={props.customer} data={state} /> 
    </>
  );
}

export default SubscriptionMessage;